import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./RoomInviteModal.module.scss";

interface RoomInviteModalProps {
  roomCode: string;
  isOpen: boolean;
  onClose: () => void;
}

const RoomInviteModal: React.FC<RoomInviteModalProps> = ({
  roomCode,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const inviteUrl = `${window.location.origin}/room/${roomCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>
          <div className={styles.textBlock}>
            <div className={styles.label}>
              {t("room_copy_invite", "Copy and send to a friend")}
            </div>
            <div className={styles.url}>{inviteUrl}</div>
          </div>
          <div className={styles.divider} />
          <button
            className={styles.copyBtn}
            onClick={handleCopy}
            aria-label="Copy link"
          >
            {copied ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2ebd85" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoomInviteModal;
